// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__m6iUb","container":"DefaultLayout_container__4Jq5G","content":"DefaultLayout_content__twAs5"};